import { AnalyticsPlugin } from '@pulse/common';
import { PulsePluginContext } from '../context';
import { ExperimentsService } from '../services/experiments.service';

/**
 * Flush messages if new experiment participation happened
 */
export class InfectedPlugin implements AnalyticsPlugin {
    constructor(private experimentsService: ExperimentsService) {}

    init(context: PulsePluginContext) {
        this.experimentsService.newExperimentTrigger$.subscribe((participated) => {
            if (participated) {
                context.tracker.flush();
            }
        });
    }
}
